import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { ProjectService } from 'src/app/dashboard/project/project.service';
import { TutorialService } from 'src/app/dashboard/tutorial/tutorial.service';
import { ConnectionsServiceEnum } from 'src/app/shared/enums/connections-service.enum';
import { FormApiValidationError } from 'src/app/shared/model/errors/formApiError.model';
import { ConnectionsService } from 'src/app/shared/service/connections.service';
import { ConnectionModel } from '../../../../../shared/model/connections.model';

@Component({
  selector: 'app-shopify-service',
  templateUrl: './shopify-service.component.html',
  styleUrls: ['./shopify-service.component.scss'],
})
export class ShopifyServiceComponent implements OnInit, OnDestroy {
  @Input() connections!: ConnectionModel[];
  @Output() connectionAttached = new EventEmitter<boolean>();

  form!: UntypedFormGroup;
  isLoading = false;
  service = ConnectionsServiceEnum.Shopify;
  project_connection_id: number | null = null;

  private onDestroy$ = new Subject<void>();

  get connection() {
    return this.form.get('connection') as UntypedFormControl;
  }

  constructor(
    private fb: UntypedFormBuilder,
    public connnectionsService: ConnectionsService,
    public projectService: ProjectService,
    public tutorialService: TutorialService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      connection: [null, [Validators.required]],
    });
  }

  attachShopifyConnection() {
    this.isLoading = true;

    this.connnectionsService
      .attachShopifyToProject(
        this.projectService.activeProject$.getValue()!.id,
        this.connection.value.id,
        this.project_connection_id)
      .pipe(
        tap(() => {
          this.form.reset();
          this.form.markAsUntouched();
          this.isLoading = false;
        }),
        takeUntil(this.onDestroy$),
      )
      .subscribe(
        () => this.connectionAttached.emit(true),
        (er: FormApiValidationError) => {
          er.setOnForm && er.setOnForm(this.form);
          this.connectionAttached.emit(false);
        },
      );
  }

  submit() {
    if (this.form.invalid) {
      return;
    }
    this.attachShopifyConnection();
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }
}
